import React from "react";

export default class LookUpData extends React.Component {
  state={
    selectedIdx: -1
  }
  render() {
    const {
      Icon,
      VARIANT,
      Bs,
      loading,
      selected,
      data,
      searchBy,
      selectedData,
    } = this.props;
    console.log("lookup-data", data);
    return (
      <>
        <Bs div className="div-lookup bg-transparent p-4">
          <Bs row className="mb-2 bg-white br-6 p-2">
            <Bs col xs={12}>
              <Bs strong>Vyhledané data</Bs>
            </Bs>
          </Bs>
          {data.map((e, idx) => (
            <Bs row className="mb-2">
              <Bs col xs={12}>
                <Bs
                  card
                  bg={VARIANT.WHITE}
                  className={(idx === selected) ? "lb-success-3" : "cursor-pointer"}
                  data-tip={(idx === selected) ? "" : "Kliknutím doplníš data do formuláře"}
                  onClick={() => {
                    if (idx !== selected) {
                      selectedData(e,idx);
                      this.setState({selectedIdx: idx})
                    }
                    }}
                >
                  <Bs modalbody>
                    <Bs row>
                      <Bs col xs={12} className="d-flex">
                        {idx === selected && (
                          <Icon aioutlinecheckcircle className="fs-20 c-success me-2" />
                        )}
                        <Bs strong>
                          <Bs small>Typ: {!searchBy ? e.api_name : searchBy}</Bs>
                        </Bs>
                      </Bs>
                      <Bs col xs={12}>
                        <Bs small>Typ přístroje: {e?.TypeName}</Bs>
                      </Bs>
                      <Bs col xs={12}>
                        <Bs small>IMEI: {e?.DeviceSN || e?.DeviceSN_cust}</Bs>
                      </Bs>
                      <Bs col xs={12}>
                        <Bs small>S/N: {e?.ProductCodeSN || e?.ProductCodeSN_cust}</Bs>
                      </Bs>
                      {}
                      <Bs col xs={12}>
                        <Bs small>Číslo RP: {e?.NumAtCard1 || e?.NumAtCard}</Bs>
                      </Bs>
                    </Bs>
                  </Bs>
                </Bs>
              </Bs>
            </Bs>
          ))}
        </Bs>
      </>
    );
  }
}
